import { combineReducers } from "redux";
import counterReducer from './counterSlice'
import globalReducer from  './globalSlice';
import  localStorage from './localStorageSlice'

const rootReducer = combineReducers({
    counter:counterReducer,
    global:globalReducer,
    localStorage:localStorage
})

export default rootReducer;